import React, { useRef, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import copy from "copy-to-clipboard";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

import useIsMobile from "src/hooks/useIsMobile";
import { Context } from "src/contexts/TinyProvider";
import ParallelogramButton from "../Button/ParallelogramButton";

import ModalActions from "../ModalActions";
import CopySvg from "../CopySvg";

import { getDisplayBalance } from "src/utils/formatBalance";
import useMyRuneBalance from "src/hooks/useMyRuneBalance";

import { getTokenImgSrc } from "src/constants/imgPaths";
import Redirect from "../Svg/Redirect";

import runeSealed from "src/images/presale-market/rune-card.png";
import LinkMetaMask from "./LinkMetaMask";
import useUserWallet from "src/hooks/useUserWallet";
interface IWalletBalance {
  icon: string;
  title: string;
  value: string;
  valueZeroHide?: boolean;
}

function WalletDetail({ cb }: { cb?: () => void }) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const { tiny, logout } = useContext(Context);
  const account = tiny.myAccount;

  const [redeemedRuneNum, startRefreshPurchasedRune] = useMyRuneBalance(1);
  const [runev2Num] = useMyRuneBalance(2);

  const {
    lockSpiritBalance,
    tincBalance,
    spiritBalance,
    bnbBalance,
    busdBalance,
    runeBalance,
  } = useUserWallet();

  const walletBalance: IWalletBalance[] = useMemo(
    () => [
      {
        icon: "//images.tinyworlds.io/tokens/TINC.png",
        title: "TINC",
        value: tincBalance ? getDisplayBalance(tincBalance) : "0",
      },
      {
        icon: "//images.tinyworlds.io/tokens/SPIRIT.png",
        title: t("staminaItem"),
        value: spiritBalance ? spiritBalance.toNumber().toString() : "0",
      },
      {
        icon: "https://images.tinyworlds.io/tokens/LOCKED-SPIRIT.png",
        title: t("lockStaminaItem"),
        value: lockSpiritBalance
          ? lockSpiritBalance.toNumber().toString()
          : "0",
        valueZeroHide: true,
      },
      {
        icon: runeSealed,
        title: t("Mystery Rune"),
        // value: (redeemedRuneNum.toNumber() + runev2Num.toNumber()).toString(),
        value: runeBalance ? runeBalance.toNumber().toString() : "0",
      },
      {
        icon: getTokenImgSrc("BNB"),
        title: "BNB",
        value: bnbBalance ? getDisplayBalance(bnbBalance, 18, 3) : "0",
      },
      {
        icon: "//images.tinyworlds.io/tokens/BUSD.png",
        title: "BUSD",
        value: busdBalance ? getDisplayBalance(busdBalance) : "0",
      },
    ],
    [
      bnbBalance,
      busdBalance,
      lockSpiritBalance,
      runeBalance,
      spiritBalance,
      t,
      tincBalance,
    ]
  );

  const fooRef = useRef<HTMLDivElement>(null);

  const handleLogout = () => {
    logout();
    cb && cb();
  };

  // onDismiss && onDismiss();
  return (
    <>
      <StyledTitle>
        <a
          target="_blank"
          href={"https://bscscan.com/address/" + tiny.myAccount}
          rel="noreferrer"
        >
          {t("Your Wallet")}
          <Redirect className={"ml-4"} color={"#514B45"} />
          {/* <img className={"ml-4"} src={redirectSvg} alt="View on BscScan" /> */}
        </a>
      </StyledTitle>

      <StyledContent>
        <StyledItem className="position-relative">
          <input type="text" disabled={true} value={tiny.myAccount} />

          <div
            className="flex-center flex"
            onClick={() => {
              console.log("account", account);
              const successd = copy(account ? account : "");
              if (successd && fooRef.current) {
                ReactTooltip.show(fooRef.current);
              }
            }}
          >
            <CopySvg fill="#514B45" />
          </div>

          <div
            style={{ position: "absolute", right: "5%", bottom: 0 }}
            data-tip
            data-for="copy-address"
            ref={fooRef}
          />

          <ReactTooltip
            place="bottom"
            id="copy-address"
            effect="solid"
            isCapture={true}
            afterShow={() => setTimeout(ReactTooltip.hide, 1000)}
            border
            textColor="#935316"
            backgroundColor="#FFBD4A"
            borderColor="#BC6C1E"
          >
            <span
              style={{
                whiteSpace: "nowrap",
              }}
            >
              {t("Copied")}
            </span>
          </ReactTooltip>
        </StyledItem>
      </StyledContent>

      <StyledContent>
        <StyledItem>
          <ul>
            {walletBalance.map(
              ({ icon, value, title, valueZeroHide }, index) => {
                const render = (
                  <li key={index}>
                    <StyledBalanceLeft>
                      <StyledIcon
                        style={
                          index === 2
                            ? {
                                height: "auto",
                                width: isMobile ? 20 : 25,
                              }
                            : undefined
                        }
                        className="mr-4"
                        src={icon}
                      ></StyledIcon>
                      <span className="mr-8">{title}</span>
                      {index === 0 && <LinkMetaMask />}
                    </StyledBalanceLeft>
                    <div>{value}</div>
                  </li>
                );
                return valueZeroHide ? (
                  Number(value) === 0 ? (
                    <></>
                  ) : (
                    render
                  )
                ) : (
                  render
                );
              }
            )}
          </ul>
        </StyledItem>
      </StyledContent>

      <ModalActions
        style={{
          height: "5rem",
          margin: "0px -8px -24px",
        }}
      >
        <ParallelogramButton onClick={handleLogout}>
          {t("Logout")}
        </ParallelogramButton>
      </ModalActions>
    </>
  );
}

export default WalletDetail;

const StyledBalanceLeft = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const StyledIcon = styled.img`
  height: auto;
  width: 25px;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    height: auto;
    width: 20px;
  `}
`;

const StyledTitle = styled.div`
  text-align: center;

  a {
    display: flex;
    align-items: center;
    margin-left: 4px;
    color: #514b45;
    justify-content: center;
    font-weight: 600;
    font-size: 1.3rem;
  }
`;
const StyledItem = styled.div`
  width: 100%;
  background-color: #fffbdd;
  border-radius: 11px;
  min-height: 2.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;

  input {
    color: #514b45;
    width: 90%;
    background: none;
    border: 0;
    font-size: 1rem;
    font-weight: 600;
  }

  ul {
    list-style: none;
    width: 100%;
    margin: 10px;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 2.6rem;
    }

    li + li {
      border-top: 1px solid #aea78a;
    }
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    font-size: 1.2rem;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 auto;
  `}
`;

const StyledContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 15px 0 0;

  .__react_component_tooltip {
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-out !important;
    opacity: 0 !important;
    visibility: visible;
  }

  .__react_component_tooltip.show {
    visibility: visible;
    opacity: 1 !important;
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    flex-direction: column;
    row-gap: 10px;
    width: 100%;
    justify-content: center;
    margin: 10px auto 0;
  `}
`;
